import App from './TorneioDomino/AppDomino.svelte'; 

const app = new App({
    target: document.getElementById("app"),
});
export default app;    